import {
  Component,
  OnInit
} from '@angular/core';
import { Router } from '@angular/router';

interface Subcategory {
  id: number;
  name: string;
  category: string;
  totalCourses: number;
}


@Component({
  selector: 'app-sub-category',
  standalone: false,
  templateUrl: './sub-category.html',
  styleUrl: './sub-category.scss',
})
export class SubCategory implements OnInit{
    pageTitle = 'Subcategory List';

  pageSubtitle =
    'View, manage, and organize all course subcategories in one place.';

  searchTerm = '';

  page = 1;
  pageSize = 9;

  subcategories: Subcategory[] = [
    {
      id: 1,
      name: 'Apple',
      category: 'Office Productivity',
      totalCourses: 0,
    },
    {
      id: 2,
      name: 'Career Development',
      category: 'Personal Development',
      totalCourses: 2,
    },
    {
      id: 3,
      name: 'Communication',
      category: 'Business',
      totalCourses: 0,
    },
    {
      id: 4,
      name: 'Creativity',
      category: 'Personal Development',
      totalCourses: 0,
    },
    {
      id: 5,
      name: 'Data Science',
      category: 'Development',
      totalCourses: 3,
    },
    {
      id: 6,
      name: 'Fashion Design',
      category: 'Design',
      totalCourses: 0,
    },
    {
      id: 7,
      name: 'Game Design',
      category: 'Design',
      totalCourses: 0,
    },
    {
      id: 8,
      name: 'Game Development',
      category: 'Development',
      totalCourses: 0,
    },
    {
      id: 9,
      name: 'Google',
      category: 'Office Productivity',
      totalCourses: 0,
    },
    {
      id: 10,
      name: 'Graphic Design',
      category: 'Design',
      totalCourses: 0,
    },
    {
      id: 11,
      name: 'Hardware',
      category: 'IT & Software',
      totalCourses: 0,
    },
    {
      id: 12,
      name: 'IT Certifications',
      category: 'IT & Software',
      totalCourses: 5,
    },
    {
      id: 13,
      name: 'Leadership',
      category: 'Business',
      totalCourses: 4,
    },
    {
      id: 14,
      name: 'Marketing Analytics',
      category: 'Marketing',
      totalCourses: 2,
    },
    {
      id: 15,
      name: 'Mobile Development',
      category: 'Development',
      totalCourses: 6,
    },
    {
      id: 16,
      name: 'Network Security',
      category: 'IT & Software',
      totalCourses: 3,
    },
  ];

  filteredSubcategories: Subcategory[] = [];

  constructor(
    private readonly router: Router
  ) {}

  ngOnInit(): void {
    this.applyFilters();
  }

  get paginatedSubcategories(): Subcategory[] {
    const startIndex =
      (this.page - 1) * this.pageSize;

    const endIndex =
      startIndex + this.pageSize;

    return this.filteredSubcategories.slice(
      startIndex,
      endIndex
    );
  }

  get startItem(): number {
    if (
      this.filteredSubcategories.length === 0
    ) {
      return 0;
    }

    return (
      (this.page - 1) * this.pageSize + 1
    );
  }

  get endItem(): number {
    return Math.min(
      this.page * this.pageSize,
      this.filteredSubcategories.length
    );
  }

  onSearchChange(): void {
    this.page = 1;
    this.applyFilters();
  }

  onPageSizeChange(event: Event): void {
    const selectElement =
      event.target as HTMLSelectElement;

    this.pageSize = Number(
      selectElement.value
    );

    this.page = 1;
  }

  applyFilters(): void {
    const normalizedSearch =
      this.searchTerm
        .trim()
        .toLowerCase();

    this.filteredSubcategories =
      this.subcategories.filter(
        (subcategory) => {
          const searchableText = [
            subcategory.name,
            subcategory.category,
            String(subcategory.totalCourses),
          ]
            .join(' ')
            .toLowerCase();

          return searchableText.includes(
            normalizedSearch
          );
        }
      );

    const lastAvailablePage = Math.max(
      1,
      Math.ceil(
        this.filteredSubcategories.length /
          this.pageSize
      )
    );

    if (this.page > lastAvailablePage) {
      this.page = lastAvailablePage;
    }
  }

  clearFilters(): void {
    this.searchTerm = '';
    this.page = 1;

    this.applyFilters();
  }

  addSubcategory(): void {
    this.router.navigate([
      '/admin/course-reference/add-subcategory'
    ]);
  }

  editSubcategory(
    subcategory: Subcategory
  ): void {
    this.router.navigate([
      '/admin/course-reference/subcategory/edit',
      subcategory.id
    ]);
  }

  deleteSubcategory(
    subcategory: Subcategory
  ): void {
    console.log(
      'Delete subcategory:',
      subcategory
    );
  }

  trackBySubcategoryId(
    _index: number,
    subcategory: Subcategory
  ): number {
    return subcategory.id;
  }
}
